module.exports = __webpack_public_path__ + "static/media/bamburgh-react-crypto-application-reactstrap-pro.9d4a854c.jpg";